module.exports = __webpack_public_path__ + "media/images/front/not-logged-in-lp-renew/img_webinar_05-e9eac9a4631b1d552d0d39cd1fc5ef0b.png";